import React from 'react';
import PostSource from "../../../components/pages/form/PostSource/PostSource";

const PostSourcePage = () => {
    return <PostSource />
};

export default PostSourcePage;